import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CancelReceiptRequest {
  receiptIds?: number[];
}

const useCancelReceiptsApi = () => {
  const call = useCallback(async ({ receiptIds }: CancelReceiptRequest = {}) => {
    try {
      const res = await axiosInstance.post(api.cancelReceipt, receiptIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { cancelReceipts: execute, cancelReceiptsLoading: isLoading };
};

export default useCancelReceiptsApi;
